<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
    <span v-if="country_code_cm == 'greece' && gateway_code =='mobivas'">
     
        <privacy-paydash-greek/>
   
    </span>
     <span v-else>
      
      <span v-if="lang_cm == 'arabic'">
        <privacy-arabic/>
      </span>
      <span v-else-if="lang_cm == 'malay'">
      </span>
      <span v-else-if="lang_cm == 'greek'">
        <privacy-greek/>
      </span>
      <span v-else-if="lang_cm == 'czech'">
        <privacy-czech/>
      </span>
      <span v-else-if="lang_cm == 'bulgarian'">
        <privacy-bulgarian/>
      </span>
      <span v-else-if="lang_cm == 'norwegian'">
        <privacy-norwegian/>
      </span>
      <span v-else-if="lang_cm == 'swedish'">
        <privacy-swedish/>
      </span>
      <span v-else-if="lang_cm == 'finnish'">
        <privacy-finnish/>
      </span>
      <span v-else-if="lang_cm == 'romanian'">
        <privacy-romanian/>
      </span>
      <span v-else>
        <privacy-english/>
      </span>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './../PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './../PrivacyPolicyArabic';
import PrivacyPolicyMalay from './../PrivacyPolicyMalay';
import PrivacyPolicyGreek from './../PrivacyPolicyGreek';
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './../PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import PrivacyPolicyPaydashGreek from './PrivacyPolicyPaydashGreek';
import PrivacyPolicyPaydashEnglish from './PrivacyPolicyPaydashEnglish';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_cm", "country_cm","gateway_code","country_code_cm"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish,
    'privacy-paydash-greek' :PrivacyPolicyPaydashGreek,
    'privacy-paydash-english':PrivacyPolicyPaydashEnglish
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.mobitxt a {
    
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cutemobi/PrivacyPolicy.vue